import React, { createContext, useContext, useEffect, useRef, useState } from "react"
//import Gaveta from "../gaveta"
import { Avatar, Box, Button, Container, Divider, Grid, IconButton, Stack, Toolbar, Typography, styled } from "@mui/material"
import { Camera as IconCamera, Cancel, Check, ImageSearchSharp, CameraAlt, Fullscreen, FullscreenExit, ZoomIn, ZoomOut } from "@mui/icons-material";
import { isEmpty, getImg } from "../../services/utils";
import Resizer from "react-image-file-resizer";
import Modal from "../modal";
import CameraImage from "./camera";
import { db } from "../../services/db";
import { AlertaProvider, useAlerta } from "../alerts/Alerts";
import NumberField from "../NumberFiedCustom";


const FileInput = ({ value, onChange, ...rest }: any) => {
    const inputRef = useRef({} as any);
    const resizeFile = (file: any) => {
        console.log("file", file);
        return new Promise((resolve) =>
            Resizer.imageFileResizer(
                file,
                1024,
                1024,
                "JPEG",
                500,
                0,
                (uri) => {
                    console.log("uri", uri)
                    resolve(uri);
                },
                "blob"
            )
        )
    }

    const handleOnChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        let blob = await resizeFile(e.target.files![0]) as Blob;
        onChange(URL.createObjectURL(blob))
    }

    return <input {...rest} style={{ display: 'none' }} type="file" accept="image/*" ref={inputRef} onChange={handleOnChange} />;
};

interface AnexarProps {
    idAnexoAtual: string;
    getBlobAnexo: (id: string) => any
    postAnexo: (file: Blob) => Promise<{ id: string }>
    handleChangeId: (id: string) => any
}



interface ViewCameraProps {
    open: boolean,
    handleClose: () => void,
    callbackTakePhoto: (value: string) => void
}

const ViewCamera = (props: ViewCameraProps) => {

    const confirmaPhoto = (value: string) => {
        props.callbackTakePhoto(value);
        props.handleClose()
    }

    return (
        <Modal
            component={
                <>{props.open && (<CameraImage callback={confirmaPhoto} cancel={props.handleClose} />)}</>
            }
            handleClose={props.handleClose}
            heigth="auto"
            width="md"
            open={props.open}
            sx={{ zIndex: 1400 }}
        />
    )
}

function Anexar(props: AnexarProps) {

    const [showViewCamera, setShowViewCamera] = useState(false);
    const [img, setImg] = useState("")
    const [title, setTitle] = useState(isEmpty(props.idAnexoAtual) ? "Adicionar Imagem" : "Alterar Imagem")
    const { showModal, handleShowModal, handleCloseModal, urlAtual, handleSetUrl } = useAnexo();
    const [redimencionar, setRedmencionar] = useState(false);
    const [widthImg, setWidithImg] = useState(100)


    useEffect(() => {
        console.log("chamou useEffect Anexar", props);
        if (props.idAnexoAtual)
            props.getBlobAnexo(props.idAnexoAtual)
    }, [])

    const previewImg = (img: string) => {
        if (img !== "") {
            setImg(img);
            setTitle("Confirmar imagem selecionada?")
        }
    }

    const cancelPreview = () => {
        setImg("");
        setTitle(isEmpty(props.idAnexoAtual) ? "Adicionar Imagem" : "Alterar Imagem")
    }


    const Content = () => {
        const { AlertaView, handleShowAlerta } = useAlerta()
        const sendBlobImg = async (url: string) => {
            let blob = await fetch(url).then(r => r.blob());
            let resp = await props.postAnexo(blob);
            console.log(resp);
            if (!isEmpty(resp.id)) {
                props.handleChangeId(resp.id);
                handleSetUrl(url);
                handleCloseModal();
            } else {
                handleShowAlerta("Ouve uma falha ao salvar a imagem.", "error")
            }
        }

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Toolbar>
                    <Typography variant="h6" sx={{ flex: 1 }} >{title}</Typography>
                    {redimencionar && (
                        <Stack flexDirection={"row"} gap={1} alignItems={"center"}>
                            <IconButton onClick={()=>setWidithImg(widthImg-1)} >
                                <ZoomOut />
                            </IconButton>

                            <Typography variant="button">{widthImg}%</Typography>

                            <IconButton onClick={()=>setWidithImg(widthImg+1)}>
                                <ZoomIn />
                            </IconButton>

                        </Stack>

                    )}
                    <IconButton
                        onClick={() => setRedmencionar(!redimencionar)}
                    >
                        {redimencionar ? <FullscreenExit titleAccess="Sair da tela cheia" /> : <Fullscreen titleAccess="Tela cheia" />}
                    </IconButton>
                </Toolbar>
                <Divider />
                <Container sx={{ display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center', alignContent: 'center' }}>
                    <ViewCamera callbackTakePhoto={previewImg} open={showViewCamera} handleClose={() => setShowViewCamera(false)} />
                    <Box sx={{ display: 'flex', flexDirection: 'column', padding: 5 }}>
                        <Avatar
                            variant="rounded"
                            src={img ? img : urlAtual}
                            style={{ width: redimencionar ? `${widthImg}%` : 150, height: redimencionar ? "auto" : 150, alignSelf: 'center', padding: 5, objectFit: "cover" }}
                        />
                        {img !== "" && (
                            <Stack direction={'row'} spacing={2} justifyContent={'center'}>
                                <IconButton color="success" size="large" onClick={() => sendBlobImg(img)}><Check fontSize="inherit" /></IconButton>
                                <IconButton color="secondary" onClick={cancelPreview}><Cancel fontSize="inherit" /></IconButton>
                            </Stack>
                        )}

                    </Box>

                    {img === "" && (
                        <Stack direction={"row"} justifyContent={"space-evenly"} flex={1} >
                            <Button
                                id="getImage"
                                color="primary"
                                component="label"
                                role={undefined}
                                variant="text"
                                tabIndex={-1}
                                startIcon={<ImageSearchSharp fontSize="large" />}
                                size="large"
                            >
                                <FileInput onChange={previewImg} />
                                Buscar Imagem
                            </Button>
                            <IconButton
                                size="large"
                                onClick={() => setShowViewCamera(true)}
                            >
                                <CameraAlt />
                            </IconButton>
                        </Stack>
                    )}
                    <AlertaView />
                </Container>


            </Box>
        )
    }

    return (
        <Modal
            component={
                <AlertaProvider>
                    <Content />
                </AlertaProvider>
            }
            handleClose={handleCloseModal}
            open={showModal}
            heigth="auto"
            width={redimencionar ? "lg" : "sm"}
            handleOnKeyDown={(ev) => { }}
        />
    )
}

interface AnexoProviderProps {
    showModal: boolean,
    handleShowModal: () => any
    handleCloseModal: () => any
    handleSetUrl: (url: any) => any
    urlAtual: any
}

function anexoProvider(): AnexoProviderProps {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [urlAtual, setUrlAtual] = useState("")

    console.log("anexoProvider urlAtual", urlAtual)
    const handleShowModal = () => {
        setShowModal(true);
    }

    const handleCloseModal = () => {
        setShowModal(false)
    }

    const handleSetUrl = (url: any) => {
        setUrlAtual(url);
    }



    return {
        showModal,
        handleCloseModal,
        handleShowModal,
        handleSetUrl,
        urlAtual
    }
}

const anexoContext = createContext<AnexoProviderProps>({} as AnexoProviderProps)

function useAnexo() {
    return useContext(anexoContext)
}

function AnexoProvider({ children }: any) {
    const provider = anexoProvider();
    return (
        <anexoContext.Provider value={provider}>
            {children}
        </anexoContext.Provider>
    )
}

export {
    AnexoProvider,
    useAnexo,
    Anexar
}